// @flow
import React from 'react';
import { useFormikContext } from 'formik';
import { STREAM_GOVERNANCE_RESOURCES_GRID_FIELDNAMES } from '@streaming-projects/orgs/enums';
import { AWS, AZURE, GCP } from '@src/constants';
import { getDropdownOptions } from '@components/stream-governance/utils';
import { SelectField } from '@src/formik-utils/FormFields';
import { STREAM_GOVERNANCE_RESOURCE_INPUTS_DETAILS_CONFIG_MAP } from '@streaming-projects/resource-definitions/stream-governance-resource-definitions/stream-governance-resource-inputs-config';

import { useSPStreamGovernanceResourceContext } from './SPStreamGovernanceResourceContextProvider';

export const SGResourceProviderNameContainer = ({
  disabled,
  disableOnFormErrors = null,
  fluid = null,
}) => {
  const { values, setFieldValue, setFieldTouched } = useFormikContext();

  const providerNameConfig = STREAM_GOVERNANCE_RESOURCE_INPUTS_DETAILS_CONFIG_MAP.get(
    STREAM_GOVERNANCE_RESOURCES_GRID_FIELDNAMES.PROVIDER
  );

  const dataUniverse = useSPStreamGovernanceResourceContext();
  const providerNameOptions = getDropdownOptions(
    dataUniverse,
    values,
    providerNameConfig,
    false,
    true,
    false,
    false,
    [AWS, AZURE, GCP]
  );

  const regionFieldName = STREAM_GOVERNANCE_RESOURCES_GRID_FIELDNAMES.REGION;

  return (
    <SelectField
      disableOnFormErrors={disableOnFormErrors}
      disabled={disabled}
      fieldDisplayName={providerNameConfig.displayName}
      fieldName={providerNameConfig.backendFieldName}
      fluid={fluid}
      onChange={async () => {
        await setFieldValue(regionFieldName, null);
        await setFieldTouched(regionFieldName, true);
      }}
      options={providerNameOptions}
      placeholder={providerNameConfig.displayName}
    />
  );
};
